import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetFilter } from "../../features/filter/filterSlice";
import { fetchTags } from "../../features/tags/tagsSlice";
import Tag from "./Tag";

export default function Tags() {
    const { tags } = useSelector((state) => state.tags);
    const { tags: filterTags, author, search } = useSelector((state) => state.filter);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchTags());
    }, [dispatch]);

    return tags?.length > 0 ? (
        <section>
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 border-b overflow-y-auto">
                {tags.map((tag) => (
                    <Tag key={tag.id} title={tag.title} />
                ))}
                {
                    (author || search || filterTags.length > 0) &&
                    <button
                        onClick={() => { dispatch(resetFilter()); navigate("/") }}
                        className="bg-red-100 text-red-600 px-4 py-1 rounded-full cursor-pointer ml-auto">
                        Clear Filter
                    </button>}
            </div>
        </section>
    ) : null;
}
